module.exports = __webpack_public_path__ + "img/p5.336de164.png";